<template>
  <main id="container">
    <div class="container">
      <div class="category-wrap">
        <h2 class="search-result-tit">통합검색</h2>
        <div class="serch-result-box">
           <div class="in-search-box">
            <div class="in-search-area">
              <input
                type="text"
                class="in-search-input"
                v-model="searchName"
                placeholder="제품명을 입력하세요."
                @keyup.enter="applyFiltersAndFetchAll()"
              />
              <button
                type="button"
                class="in-search-button"
                @click="applyFiltersAndFetchAll()"
              >
                <i class="icon">
                  <img src="@/assets/img/common/ico-search-result-btn.svg" alt="검색" />
                </i>
              </button>
            </div>
          </div>
        </div>
        <div class="result-txt-wrap">
          <div class="result-txt">
            <b>'{{ searchName }}'</b>의 키워드로 총 <b>{{ totalCount }}</b>건이 검색되었습니다.
          </div>
        </div>

        
        <div class="products-list" v-if="items && items.length > 0">
          <products-item
            v-for="(item, index) in items"
            :key="item.id"
            :id="item.id"
            :item="item"
            :num="index"
            parent-click-evnt-nm="modalClicked"
            @modalClicked="handleClickModal"
          />
        </div>
        <div class="products-list" v-else>
          <div class="w-100">
            <div class="no-data-msg">검색 결과가 없습니다.</div>
            <div class="no-data-info">
              <ul>
                <li>-단어의 철자가 정확한지 확인해 보세요.</li>
                <li>-한글을 영어로 혹은 영어를 한글로 입력했는지 확인해 보세요.</li>
                <li>-검색어의 단어 수를 줄이거나 보다 일반적인 검색어로 다시 검색해 보세요.</li>
                <li>-두 단어 이상의 검색어인 경우, 띄어쓰기를 확인해 보세요.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="btn-more-cont-wrap" v-if="items.length < totalCount">
        <button type="button" class="btn-more-cont" @click="loadMore">
          <span>상품 더보기 ({{ items.length }}/{{ totalCount }})</span>
        </button>
      </div>
    </div>

    <!-- Shared Modal -->
    <products-modal
      :visible="visibleModal"
      @closeModal="visibleModal = false"
      :item="modalItem"
    />
  </main>
</template>

<script>
import ProductsItem from '@/components/content/ProductsItem.vue';
import ProductsModal from "@/components/content/ProductsModal";

export default {
  name: "SearchResultPage",
  components: {
    ProductsItem,
    ProductsModal
  },
  data() {
    return {
      searchName: "",
      manprdAllList: [],
      items: [],
      pageNo: 1,
      pageSize: 12,
      totalCount: 0,
      visibleModal: false,
      modalItem: null
    };
  },
  created() {
    // URL에서 검색어 읽어오기 (검색창에 검색어 유지)
    this.searchName = this.$route.query.q || "";

    //세션스토리지에 저장된 상품리스트 가져오기
    const savedData = sessionStorage.getItem('search_results');

    if (savedData) {
      this.manprdAllList = JSON.parse(savedData);
      this.totalCount = this.manprdAllList.length;

      this.getManprdList(1);
    } else {
      // 만약 세션에 검색 결과가 없다면 전체 리스트에서 필터링 시도
      this.applyFiltersAndFetchAll();
    }
  },
  computed: {
    queries() {
      return { q: this.searchName};
    }
  },
  methods: {
    handleSearch() {
      if (!this.searchName) return;
      this.applyFiltersAndFetchAll();
    },
    handleClickModal(id) {
      this.modalItem = this.items.find(i => i.id === id);
      this.visibleModal = true;
    },
    loadMore() {
      this.pageNo++;
      this.getManprdList(this.pageNo, true);
    },
    // 상품리스트 페이지네이션 처리
    getManprdList(pageNo, isAppend = false) {
        
        this.pageNo = pageNo || 1;
        const start = (this.pageNo - 1) * this.pageSize;
        const end = start + this.pageSize;
        const nextItems = this.manprdAllList.slice(start, end);

        if (isAppend) {
          this.items = [...this.items, ...nextItems];
        } else {
          this.items = nextItems;
          window.scrollTo(0, 0);
        }
    },
    // 검색시 호출되는 함수
    applyFiltersAndFetchAll() {
        const dataTemp = sessionStorage.getItem('manprdAllList');

        if (!dataTemp) return;

        // 원본을 임시변수 originList에 저장
        const originList = JSON.parse(dataTemp);

        // 원본에서 검색어를 포함하는 상품만 필터링하여 manprdAllList에 저장
        this.manprdAllList = originList.filter((m) =>
            m.title.toLowerCase().includes(this.searchName.toLowerCase())
          );
        
        // 전체 개수를 갱신 (페이징을 새로 하기 위해)
        this.totalCount = this.manprdAllList.length;

        // 세션에 필터링된 결과 저장
        sessionStorage.setItem('search_results', JSON.stringify(this.manprdAllList));

        this.getManprdList(1);
    }
  }
};
</script>

<style scoped>
#container {
  padding-bottom:100px;
}
.search-result-tit {
  padding:32px 0 24px;
  border-bottom:2px solid #2567B0;
  font-family: "Pretendard";
  font-size:36px;
}
.in-search-box {
  display:flex;
  justify-content: center;
  margin:24px 0 64px;
}
.in-search-area {
  display:flex;
  max-width:752px;
  width:100%;
}
.in-search-input {
  padding:0 16px;
  border: 2px solid #075D5D;
  border-radius:8px;
  width:100%;
  height:72px;
  font-size:25px;
  color:#555;
  background:#fff;
}
.in-search-button {
  border:2px solid #075D5D;
  border-radius:8px;
  min-width:72px;
  height:72px;
  background:#075D5D;
}
.no-data-msg {
  padding: 40px 0 50px;
  width: 100%;
  text-align: center;
  line-height:1.5;
  font-size:21px;
  color:#1d1d1d;
  font-weight:700;
}
.no-data-info {
  padding:24px 30px;
  border-top: 2px solid #097C7C;
  border-bottom: 1px solid #CCC;
  width:100%;
}
.no-data-info li {
  position:relative;
  padding-left:24px;
  line-height:1.5;
  font-size:15px;
  color:#555;
}
.no-data-info li:before {
  position:absolute;
  left: 10px;
  top: 10px;
  content:"";
  border-radius:50%;
  width:3px;
  height:3px;
  background:#555;
}
.result-txt-wrap {
  margin-bottom:30px;
}
.result-txt {
  line-height: 150%;
  font-size: 17px;
  color: #555;
}
.result-txt b {
  color:#FF3600;
  font-weight:700;
}
@media(max-width: 1024px) {
  .in-search-input {
    height:60px;
    font-size:20px;
  }
  .in-search-button {
    min-width:60px;
    height:60px;
  }
  .in-search-button img {
    width:32px;
  }
  .products-list .products-item {
    width:calc(33.333% - 14px)
  }
}
@media(max-width: 800px) {
  .in-search-box {
    margin-bottom:40px;
  }
  .in-search-input {
    height:50px;
    font-size:15px;
  }
  .in-search-button {
    min-width:50px;
    height:50px;
  }
  .in-search-button img {
    width:26px;
  }
  .result-txt {
    font-size: 15px;
  }
  .products-list .products-item {
    width: calc(50% - 5px);
  }
}
</style>

